<template>
  <v-card tile elevation="0" :class="grid.outer">
    <v-row
      no-gutters
      :justify="component.settings.justify"
      :style="
        'min-height: ' +
          component.settings.boxHeight +
          'px;' +
          'margin-left: ' +
          marginLeftResponsive +
          'px;' +
          'margin-right: ' +
          marginRightResponsive +
          'px;'
      "
      :align="component.settings.align"
    >
      <v-col xs="12" :md="component.settings.cols">
        <v-card tile elevation="0" :class="grid.inner">
          <v-row no-gutters align="center" justify="center">
            <v-checkbox v-model="privacyCheckbox" dark></v-checkbox>
            <span
              :style="
                'font-family: ' +
                  component.signing.font +
                  ' !important;' +
                  'color: ' +
                  component.signing.color +
                  ';' +
                  'font-size: ' +
                  component.signing.size +
                  'px;' +
                  'font-weight: ' +
                  component.signing.weight +
                  ';' +
                  'line-height: ' +
                  component.signing.lineHeight +
                  ';' +
                  'font-style: ' +
                  component.signing.style +
                  ';'
              "
              :class="component.signing.floatText + ' mr-1'"
            >
              <div>I agree to the</div>
            </span>
            <span
              :style="
                'font-family: ' +
                  component.terms.font +
                  ' !important;' +
                  'color: ' +
                  component.terms.color +
                  ';' +
                  'font-size: ' +
                  component.terms.size +
                  'px;' +
                  'font-weight: ' +
                  component.terms.weight +
                  ';' +
                  'line-height: ' +
                  component.terms.lineHeight +
                  ';' +
                  'font-style: ' +
                  component.terms.style +
                  ';'
              "
              :class="component.terms.floatText + ' mr-1'"
            >
              <div>{{ component.terms.value }}</div>
            </span>
            <span
              :style="
                'font-family: ' +
                  component.signing.font +
                  ' !important;' +
                  'color: ' +
                  component.signing.color +
                  ';' +
                  'font-size: ' +
                  component.signing.size +
                  'px;' +
                  'font-weight: ' +
                  component.signing.weight +
                  ';' +
                  'line-height: ' +
                  component.signing.lineHeight +
                  ';' +
                  'font-style: ' +
                  component.signing.style +
                  ';'
              "
              :class="component.signing.floatText + ' mr-1'"
            >
              <div>and</div>
            </span>
            <span
              :style="
                'font-family: ' +
                  component.terms.font +
                  ' !important;' +
                  'color: ' +
                  component.terms.color +
                  ';' +
                  'font-size: ' +
                  component.terms.size +
                  'px;' +
                  'font-weight: ' +
                  component.terms.weight +
                  ';' +
                  'line-height: ' +
                  component.terms.lineHeight +
                  ';' +
                  'font-style: ' +
                  component.terms.style +
                  ';'
              "
              :class="component.signing.floatText"
            >
              <div>Privacy Policy</div>
            </span>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  components: {},
  // Props
  props: {
    component: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  created() {
    // this.locale = this.$i18n.locale
    // console.log(this.text);
  },
  computed: {
    text() {
      let val;

      // Priority order for text source:
      // 1. Explicit value prop
      // 2. Settings value
      // 3. Fallback text from settings
      // 4. Default fallback
      if (
        this.component.value !== null &&
        this.component.value !== undefined &&
        this.component.value !== ""
      ) {
        val = this.component;
      } else if (this.component && this.component.value) {
        val = this.component.value;
      } else if (this.component && this.component.fallbackText) {
        val = this.component.fallbackText;
      } else {
        val = "Text not configured";
      }

      // Add suffix if provided
      if (this.component.suffix) {
        return this.$t(val) + " " + this.$t(this.component.suffix);
      } else {
        return this.$t(val);
      }
    },
    /**
     * Returns text with HTML tags stripped for plain text display
     */
    strippedText() {
      // Create a temporary div element to parse HTML
      const div = document.createElement("div");
      div.innerHTML = this.text;
      return div.textContent || div.innerText || "";
    },
    grid() {
      return this.$store.getters.grid;
    },
    marginLeftResponsive() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 8;
        case "sm":
          return 8;
        case "md":
          return 8;
        case "lg":
          return this.component.settings.marginLeft;
        case "xl":
          return this.component.settings.marginLeft;
      }
      return this.settings.marginLeft;
    },
    marginRightResponsive() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 8;
        case "sm":
          return 8;
        case "md":
          return 8;
        case "lg":
          return this.component.settings.marginRight;
        case "xl":
          return this.component.settings.marginRight;
      }
      return this.component.settings.marginRight;
    }
  },
  methods: {}
};
</script>

<style scoped>
/* Force all hyperlinks in HTML content to be blue and underlined */
::v-deep a {
  color: #1976d2 !important;
  text-decoration: underline !important;
}

/* Additional specificity for nested elements */
::v-deep div a,
::v-deep p a,
::v-deep span a,
::v-deep strong a,
::v-deep em a,
::v-deep b a,
::v-deep i a {
  color: #1976d2 !important;
  text-decoration: underline !important;
}
</style>
